import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Modal({children,...props}) {
  return (
      <Dialog
        TransitionComponent={Transition}
        keepMounted
        {...props}
      >
          {children}
      </Dialog>
  );
}

